import { ReactComponent as IconPin } from "assets/images/icons/pin-white.svg";
import Panel from "pages/Dashboard/Panel";
import BulletinTeaser from "features/bulletins/components/BulletinTeaser";
import useViewData from "features/view/hooks/useViewData";
import Alert from "components/ui/Alert/Alert";

function BulletinPanel() {
  const { view, isLoading } = useViewData('bulletin/dashboard');

  let content;
  if (!isLoading) {
    if (view) {
      content = view.map(
        bulletin => {
          return (
            <BulletinTeaser key={ bulletin.nid }
                            data={ bulletin }
                            hideUserDetail={ false }
                            hideEditButtons={ true }/>
          );
        }
      );
    } else {
      content = <Alert message={ `Het ophalen van de prikbordberichten is mislukt.` }/>;
    }
  }

  return (
    <Panel title={ 'Nieuwste prikbordberichten' }
           showAllPath={ '/prikbord' }
           linkLabel={ 'Alle prikbordberichten' }
           icon={ <IconPin/> }>
      <div className={ 'teasers-container--2col' }>
        { content }
      </div>
    </Panel>
  );
}

export default BulletinPanel;
